import React, { useEffect } from "react";
import { motion } from "framer-motion";
import AOS from "aos";
import "aos/dist/aos.css";
import "./tools.css";

import one from "../../assets/azureimages/tool/Azure Active Directory.png";
import two from "../../assets/azureimages/tool/Azure App Service.png";
import three from "../../assets/azureimages/tool/Azure Application Insights.png";
import four from "../../assets/azureimages/tool/Azure Bicep.png";
import five from "../../assets/azureimages/tool/Azure Blob Storage.png";
import six from "../../assets/azureimages/tool/Azure Cosmos DB 4.png";
import seven from "../../assets/azureimages/tool/Azure Cosmos DB 4.png";
import eight from "../../assets/azureimages/tool/Azure Firewall.png";
import nine from "../../assets/azureimages/tool/Azure Functions.png";
import ten from "../../assets/azureimages/tool/Azure Kubernetes Service (AKS).png";
import elven from "../../assets/azureimages/tool/Azure Load Balancer.png";
import twele from "../../assets/azureimages/tool/Azure Log Analytics.png";
import twele2 from "../../assets/azureimages/tool/Azure Monitor.png";
import twele3 from "../../assets/azureimages/tool/Azure PowerShell.png";
import twele4 from "../../assets/azureimages/tool/Azure Resource Manager (ARM).png";
import twele5 from "../../assets/azureimages/tool/Azure Virtual Machines (VMs).png";
import twele6 from "../../assets/azureimages/tool/Azure Virtual Network (VNet).png";
import twele7 from "../../assets/azureimages/tool/AzureCLI.png";
import twele8 from "../../assets/azureimages/tool/AzurePortal.png";
import twele9 from "../../assets/azureimages/tool/azuredevops.png";
import twele0 from "../../assets/azureimages/tool/sql.png";




const clients = [
  { src: one, alt: "Apache JMeter" },
  { src: two, alt: "Appium" },
  { src: three, alt: "Appium JPG" },
  { src: four, alt: "Cucumber" },
  { src: five, alt: "Java" },
  { src: six, alt: "Jenkins" },
  { src: seven, alt: "JUnit" },
  { src: eight, alt: "LoadRunner" },
  { src: nine, alt: "Postman" },
  { src: ten, alt: "Selenium" },
  { src: elven, alt: "SoapUI" },
  { src: twele, alt: "TestNG" },
  // { src: twele1, alt: "TestNG" },
  { src: twele2, alt: "TestNG" },
  { src: twele3, alt: "TestNG" },
  { src: twele4, alt: "TestNG" },
  { src: twele5, alt: "TestNG" },
  { src: twele6, alt: "TestNG" },
  { src: twele7, alt: "TestNG" },
  { src: twele8, alt: "TestNG" },
  { src: twele9, alt: "TestNG" },
  { src: twele0, alt: "TestNG" },

];

function Tools() {
  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  return (
    <>
      <section style={{ marginTop: "50px" }}>
        <div className="headlines-for-all">
          <h4     data-aos="fade-up" >
            <span>Tools </span> Covered
          </h4>
          <p     data-aos="fade-up">
         Gain hands-on experience with the most in-demand Azure cloud tools and services used by industry professionals.
          </p>
        </div>
      </section>

      <section className="our-clients-section">
        <div className="our-clients-container">
          <motion.div
            className="our-clients-track"
            animate={{ x: ["0%", "-100%"] }}
            transition={{
              ease: "linear",
              duration: 100,
              repeat: Infinity,
            }}
          >
            {[...clients, ...clients].map((client, i) => (
              <div
                className="client-item"
                key={i}
                data-aos="fade-up"
                data-aos-delay={i * 150} // DELAY ONE-BY-ONE
              >
                <img src={client.src} alt={client.alt} />
              </div>
            ))}
          </motion.div>
        </div>
      </section>
    </>
  );
}

export default Tools;
